import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Card, Page, Spinner, TextButton, Typography } from 'seagull';
import { routes } from "../../../constants";
import { useIoContext, useStore } from "../../../contexts";
import { useOnMount } from "../../../hooks/useOnMount";
import { selectors } from "../../../store/state-selectors";
import styles from "./SlackViaZapierPage.module.scss";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { getHelpArticle } from "../../../infra/utils";
export const jsID = 'zapier-elements-js';
export const cssID = 'zapier-elements-css';
export const defaultJsURL = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js';
export const defaultCssURL = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css';
var LoadZapierStatus = /*#__PURE__*/function (LoadZapierStatus) {
  LoadZapierStatus["Loading"] = "loading";
  LoadZapierStatus["Success"] = "success";
  LoadZapierStatus["Error"] = "error";
  return LoadZapierStatus;
}(LoadZapierStatus || {});
function loadZapierJsAndCss(jsURL, cssURL) {
  const loadJS = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(jsID);
    if (existingScript) {
      return resolve(null);
    }
    const script = document.createElement('script');
    script.id = jsID;
    script.type = 'module';
    script.src = jsURL;
    script.onload = () => resolve(null);
    script.onerror = () => reject();
    document.head.appendChild(script);
  });
  const loadCSS = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(cssID);
    if (existingScript) {
      return resolve(null);
    }
    const stylesheet = document.createElement('link');
    stylesheet.id = cssID;
    stylesheet.rel = 'stylesheet';
    stylesheet.href = cssURL;
    stylesheet.onload = () => resolve(null);
    stylesheet.onerror = () => reject();
    document.head.appendChild(stylesheet);
  });
  return Promise.all([loadJS, loadCSS]).then(() => null);
}
const uiMap = {
  [LoadZapierStatus.Success]: function SuccessState() {
    const userEmail = useStore(selectors.user.email);
    const userFirstName = useStore(selectors.user.firstName);
    const userLastName = useStore(selectors.user.lastName);
    return /*#__PURE__*/React.createElement(Card, {
      autoHeight: true,
      padding: "m"
    }, /*#__PURE__*/React.createElement("zapier-zap-templates", {
      "data-testid": "zapier-zap-templates",
      "sign-up-email": userEmail,
      "sign-up-first-name": userFirstName,
      "sign-up-last-name": userLastName,
      "client-id": "ieG0DJXKRhT4gI3t1DfefyH3YmooofjSMrEecI1t",
      theme: "light",
      ids: "1308170,1230341,1223023,1307798,1306468,1388914,1233302,1616853",
      limit: 5,
      "use-this-zap": "show"
    }));
  },
  [LoadZapierStatus.Loading]: function LoadingState() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.centeredBox,
      "data-testid": "zapier-loading"
    }, /*#__PURE__*/React.createElement(Spinner, null));
  },
  [LoadZapierStatus.Error]: function ErrorState() {
    const {
      locationReload
    } = useIoContext();
    return /*#__PURE__*/React.createElement("div", {
      className: styles.centeredBox,
      "data-testid": "zapier-error"
    }, /*#__PURE__*/React.createElement(Typography, null, "An error occurred. ", /*#__PURE__*/React.createElement(TextButton, {
      onClick: () => locationReload()
    }, "Reload"), " to try again."));
  }
};
export default function SlackViaZapierPage(props) {
  const {
    jsURL = defaultJsURL,
    cssURL = defaultCssURL
  } = props;
  const history = useHistory();
  const [loadZapierStatus, setLoadZapierStatus] = useState(null);
  useOnMount(() => {
    setLoadZapierStatus(LoadZapierStatus.Loading);
    loadZapierJsAndCss(jsURL, cssURL).then(() => setLoadZapierStatus(LoadZapierStatus.Success)).catch(() => setLoadZapierStatus(LoadZapierStatus.Error));
  });
  return /*#__PURE__*/React.createElement(Page, {
    "data-testid": "slack-via-zapier",
    header: "Recommended Slack Zaps",
    subheader: /*#__PURE__*/React.createElement(React.Fragment, null, "Automate workflows with Anchor and Slack using Zapier's templates. ", /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      href: getHelpArticle('7833601-what-anchor-zaps-can-i-create')
    }, "Read more")),
    onClickBack: () => history.push(routes.integrations)
  }, loadZapierStatus && /*#__PURE__*/React.createElement(uiMap[loadZapierStatus]));
}